export const zIndex = {
  header: 10,
  mobileNav: 12,
  mobileNavButtons: 13,
  portal: 20,
  cookieBar: 28,
  pageTransitionMask: 30,
}
